import { CSSObject } from '@emotion/react';
import LogoIcon from '@/assets/icons/logo.svg?react';
import { WidgetLayout } from '@/modules/models/WidgetLayout';
import type { AnimationType } from './animations';

const animation = {
  container: {
    mobile: {
      open: 'slideUpIn' as AnimationType,
      close: 'slideUpOut' as AnimationType,
    },
    desktop: {
      open: 'slideUpIn' as AnimationType,
      close: 'slideUpOut' as AnimationType,
    },
  },
  bubble: {
    show: 'showMessage' as AnimationType,
  },
  widget: {
    default: {
      text: {
        open: 'fadeIn',
        close: 'fadeOut',
      },
    },
    side: {
      openWidget: 'slideRightIn' as AnimationType,
      closeButton: 'zoomIn' as AnimationType,
      background: {
        open: 'fadeIn',
        close: 'fadeOut',
      },
    },
  },
};

const isDemoEnv = window.location.pathname.includes('/apps/config-builder');
export const theme = {
  animation: animation,
  inputType: 'textarea' as 'text' | 'textarea',
  global: {
    a: {
      pointerEvents: isDemoEnv ? 'none' : 'auto',
    },
    'button.product-button': {
      pointerEvents: isDemoEnv ? 'none' : 'auto',
    },
  } as Record<string, CSSObject>,
  isRtl: false,
  colors: {
    light: '',
    dark: '',
  },
  fontFamily: 'Benton Sans',
  zIndexApp: 1000,
  mediaMobile: 'max-width: 768px',
  widget: {
    widgetLayout: WidgetLayout.DEFAULT,
    wrapper: {
      styles: {},
      mobile: {},
      desktop: {},
    },
    content: {
      styles: {},
      mobile: {},
      desktop: {},
    },
    star: {},
    starsContainer: {},
    background: {
      title: {},
      tooltip: {},
    },
    closeButton: {},
    title: {},
    popup: {},
  },
  container: {
    mobile: {},
    desktop: {},
    styles: {},
  },
  messages: {
    mobile: {},
    desktop: {},
    styles: {},
  },
  header: {
    icon: LogoIcon,
    closeButton: {},
    mobile: {},
    desktop: {},
    styles: {},
  },
  prompts: {
    mobile: {},
    desktop: {},
    styles: {},
    item: {
      mobile: {},
      desktop: {},
      styles: {},
    },
  },
  chat: {},
  footer: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  poweredBy: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  bubble: {
    ml: {
      borderColor: '#C7C7C7',
      backgroundColor: '#FCFAF8',
      mobile: {},
    },
    user: {
      mobile: {},
    },
    styles: {},
  },
  messageText: {
    ml: {
      color: '#000',
      mobile: {},
      '.product-button': {},
    },
    user: {
      color: '#000',
      mobile: {},
    },
  },
  appWrapper: {
    mobile: {
      open: {},
      close: {},
    },
    desktop: {
      open: {},
      close: {},
    },
  },
  outerWrapper: {
    mobile: {
      open: {},
      close: {},
    },
    desktop: {
      open: {},
      close: {},
    },
  },
  input: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  sendButton: {
    desktop: {},
    mobile: {},
    styles: {},
  },
  uploadButton: {
    styles: {},
  },
  dropdown: {},
  variants: {
    wrapper: {},
    option: {},
  },
  singleChoice: {},
  singleChoiceButton: {},
  multiChoice: {},
  multiChoiceButton: {},
  maintenance: {
    styles: {},
    groupButton: {
      styles: {},
      active: {},
    },
  },
  embeddedPage: {
    global: {},
    wrapper: {
      desktop: {},
      mobile: {},
      styles: {},
    },
    content: {
      desktop: {},
      mobile: {},
      styles: {},
    },
    prompts: {
      mobile: {},
      desktop: {},
      styles: {},
      item: {
        mobile: {},
        desktop: {},
        styles: {},
      },
    },
    heading: {
      mobile: {},
      desktop: {},
      styles: {},
    },
    subHeading: {
      mobile: {},
      desktop: {},
      styles: {},
    },
    input: {
      mobile: {},
      desktop: {},
      styles: {},
    },
    welcomeScreen: {
      mobile: {},
      desktop: {},
      styles: {},
    },
  },
};

export type RecursivePartial<T> = {
  [P in keyof T]?: RecursivePartial<T[P]>;
};

export type ThemeType = typeof theme;
export type ThemeTypeOptional = RecursivePartial<typeof theme>;
